import { render, staticRenderFns } from "./UserProfileInfo.vue?vue&type=template&id=f97cc5bc&"
import script from "./UserProfileInfo.vue?vue&type=script&lang=js&"
export * from "./UserProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports